module.exports = __webpack_public_path__ + "static/img/2.adba820.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/2.png
// module id = B8sb
// module chunks = 1